import { createStore, applyMiddleware } from "redux";
import rootReducer from "./root_reducer";
import thunk from "redux-thunk";

export const globalStore = createStore(
	rootReducer,
	{},
	applyMiddleware(thunk),
);